export const generateMockChannelConfiguration = () => ({
  EMAIL: {
    enabled: false,
  },
  IN_APP: {
    enabled: true,
  },
  SLACK: {
    enabled: false,
    slackChannels: [],
    integrationInstanceId: '',
  },
});
